<div class="agents">
  <table class="list">
    <thead>
      <tr>
        <th>{{ 'label.Name' | translate }}</th>
        <th>{{ 'label.Surname' | translate }}</th>
        <th>{{ 'label.Email' | translate }}</th>
        <th>{{ 'label.PhoneNumber' | translate }}</th>
        <th>{{ 'label.Position' | translate }}</th>
        <th>{{ 'label.Status' | translate }}</th>
        <th>{{ 'label.ProfileOwner' | translate }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of customer?.agentList">
        <td>{{ item.name }}</td>
        <td>{{ item.surname }}</td>
        <td>{{ item.email }}</td>
        <td>
          <span *ngIf="item.phoneNumber"
            >{{ item.phoneNumber }}
            <span *ngIf="item.phoneNumberExtension"
              >({{ item.phoneNumberExtension }})</span
            ></span
          >
          <span *ngIf="item.mobilePhoneNumber"
            ><br />{{ item.mobilePhoneNumber }}</span
          >
          <span *ngIf="item.mobilePhoneNumber2"
            ><br />{{ item.mobilePhoneNumber2 }}</span
          >
        </td>
        <td>{{ item.position }}</td>
        <td>{{ item.status | translate }}</td>
        <td>
          <i *ngIf="item.isProfileOwner" class="fa fa-check"></i>
        </td>
        <td class="agent-actions">
          <a
            *ngIf="item.statusId != CustomerAgentStatusEnum.Deleted"
            class="fa fa-pencil-square-o"
            (click)="onEditAgentClick(item)"
            [title]="'label.Edit' | translate"
          ></a>
          <span
            *ngIf="item.statusId == CustomerAgentStatusEnum.Pending"
            (click)="onActivationLink(panel2, item.customerAgentId, $event)"
            class="fa fa-link"
            [title]="'label.ActivationLink' | translate"
          ></span>
          <span
            *ngIf="item.statusId != CustomerAgentStatusEnum.Deleted"
            (click)="onResetPassword(panel, item.customerAgentId, $event)"
            class="fa fa-lock"
            [title]="'label.ResetPassword' | translate"
          ></span>
          <span
            *ngIf="
              !item.isProfileOwner &&
              item.statusId == CustomerAgentStatusEnum.Inactive
            "
            (click)="onActivate(item)"
            [title]="'label.Activate' | translate"
            class="fa fa-check-circle-o"
          ></span>
          <span
            *ngIf="
              !item.isProfileOwner &&
              item.statusId == CustomerAgentStatusEnum.Active
            "
            (click)="onDeactivate(item)"
            [title]="'label.Deactivate' | translate"
            class="fa fa-ban"
          ></span>
          <span
            *ngIf="
              !item.isProfileOwner &&
              item.statusId !== CustomerAgentStatusEnum.Deleted
            "
            (click)="onDeleteCustomerAgentClick(item)"
            [title]="'label.Delete' | translate"
            class="fa fa-times-circle"
          ></span>
        </td>
      </tr>
    </tbody>
  </table>
  <a (click)="onAddNewAgent()">{{ 'label.AddNew' | translate }}</a>
</div>
<p-overlayPanel #panel (onBeforeHide)="clear($event)">{{
  resetPassword
}}</p-overlayPanel>
<p-overlayPanel #panel2> {{ customer?.activationLink }}</p-overlayPanel>
